import React, { useEffect, useState } from "react";
import "./AssignmentSection.scss";
import Button from "../Components/Buttons/Button";
import CategoryCard from "./Card/CategoryCard";
import { getCategoryWiseSubcategory } from "../services/getCategoryWiseSubcategory";

const AssignmentSection = ({ setTypeData, setIsModelOpen }) => {
  const [pageData, setPageData] = useState([]);
  const fetchData = async () => {
    await getCategoryWiseSubcategory("65524e633c005ef3b51907c9")
      .then((data) => {
        setPageData(data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!pageData?.subCategory?.length) {
    return null;
  }

  return (
    <div className="container">
      <div className="background-shadow assignmentsection">
        <div className="title">Assignment Help</div>
        <div className="description">
          Expert assistance for assignments with on-time delivery.
        </div>
        <div className="card-wrapper">
          <div className="row justify-content-center">
            {pageData?.subCategory?.map((item, index) => (
              <div
                key={index}
                className="col-12 col-sm-6 col-md-4 col-lg-4 d-flex justify-content-center mb-4"
              >
                <CategoryCard details={item} />
              </div>
            ))}
          </div>
        </div>
        <Button
          text="Get Assignment Help"
          varient="primary"
          onClick={() => {
            setTypeData({
              serviceType: "AssignmentHelp",
              type: "assignmentHelp",
              totalSteps: 1,
            });
            setIsModelOpen(true);
          }}
        ></Button>
      </div>
    </div>
  );
};

export default AssignmentSection;
